import { Active, Inactive, Section, Sections } from "@pulse/features/Sections";

import { TitleEdit } from "./Form/Title/TitleEdit";
import { TitleDisplay } from "./Form/Title/TitleDisplay";
import QuestionSections from "./Form/Question/QuestionSections";
import { AddQuestion } from "./Form/AddQuestion";
import { FirstQuestionPlaceholder } from "./Form/AddQuestion/FirstQuestionPlaceholder";

import { Link } from "@tanstack/react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import usePulseId from "@pulse/hooks/usePulseId";
import { useCurrentQuestions } from "@pulse/hooks/surveyHooks";
import { Card, CardContent, Separator, PageHeaderBack } from "frontend-components";
import DeleteSurveyButton from "./DeleteSurvey/DeleteSurveyButton";
import AddParticipantsButton from "./AddParticipants/AddParticipantsButton";
import { PreviewSurveyButton } from "./PreviewSurvey/PreviewSurveyButton";

function QuestionsArea() {
    const { data: questions } = useCurrentQuestions();

    if (!questions || questions.length === 0) {
        return <FirstQuestionPlaceholder />;
    }

    return (
        <>
            <Separator />
            <QuestionSections />
            <AddQuestion />
        </>
    );
}

export function SurveyEdit() {
    const { t } = useTranslation();
    const pulseId = usePulseId();

    return (
        <div className="flex flex-col gap-4">
            <PageHeaderBack>
                <Link
                    to="/$customerId/pulse/$pulseId"
                    from="/$customerId"
                    params={{ pulseId: String(pulseId) }}
                    className="group text-text-secondary inline-flex items-center gap-2 self-start text-sm hover:underline"
                >
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                        className="text-compendia-greige group-hover:text-compendia-foreground size-4 transition-all duration-300 ease-out group-hover:-translate-x-1"
                    />
                    {t("survey.backToOverview")}
                </Link>
            </PageHeaderBack>
            <Card className="border-compendia-greige border shadow-sm w-full">
                <CardContent className="flex flex-col gap-7">
                    <Sections>
                        <Section sectionId="survey-title">
                            <Active>
                                <TitleEdit />
                            </Active>
                            <Inactive>
                                <TitleDisplay />
                            </Inactive>
                        </Section>
                        <QuestionsArea />
                    </Sections>
                    <div className="flex flex-wrap justify-center gap-4 sm:justify-end">
                        <DeleteSurveyButton />
                        <PreviewSurveyButton />
                        <AddParticipantsButton />
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
